export default __webpack_public_path__ + "static/media/480_dummy2016-friseur01-de.350df553.png";